import { render, staticRenderFns } from "./DatePickerV2.vue?vue&type=template&id=b52af22c"
import script from "./DatePickerV2.vue?vue&type=script&lang=js"
export * from "./DatePickerV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports